module.exports = __webpack_public_path__ + "static/media/hand-paper.3903337b.svg";